/**
 * This is import script.js file
 */
import ActionsDetail from '@/components/actions-detail';

export default {
    name: 'Conciliation2Import',
    components: {
        ActionsDetail
    },
    /**
     * @override
     */
    data() {
        return {
            loading: false,
            loadEnd: false,
            bottom: false,
            file: null,
            modalId: 'detalles_subida',
            processed: {
                total: 0,
                ko: 0,
                ok: 0,
                existents: 0
            }
        };
    },
    methods: {
        /**
         * Close modal
         * @override
         */
        close() {
            this.$emit('close');
        },
        /**
         * @override
         */
        uploadFile() {
            const promises = [];
            this.file.forEach(file => {
                const toUpload =  {
                    type: 'conciliation2',
                    fileToUpload: file
                };
                promises.push(this.$importService.uploadWithoutProgress(toUpload));
            });
            this.loading = true;
            Promise.all(promises)
                .then(() => {
                    this.$toast.success('Importación realizada', 'La importación se ha realizado con éxito.');
                    this.$emit('fetch_data');
                })
                .catch(err => this.$toast.error('Error', err))
                .finally(() => {
                    this.loading = false;
                    this.loadEnd = true;
                });
        },
        /**
         * @override
         */
        uploadJsonFile() {
            const maxSize = 300 * 1024 * 1024; // 300MB
            this.file = [...this.$refs.filesRef.files].filter( f => {
                if (f.size >= maxSize ) {
                    this.$toast.error('Tamaño incorrecto', 'No se permite archivos más grandes de 300MB.');
                }
                return f.type === 'text/plain' && f.size < maxSize;
            });
        }
    }

};
